
<template>
    <div class="footerBottom">
        <div class="globelBannerSection">
            <div class="flx-center">
                <div
                    ref="globelBackground"
                    class="globelBackground"
                    :style="bannerStyle"
                ></div>
            </div>
            <div class="container globelTitleOverlay">
                <div ref="globelTitleBox" class="globelTitleBox flx-wrap">
                    <div class="globelTitle">简介</div>
                    <div class="globelContent">美通设立国内分公司30多家，每家分公司都建立了周转和存储仓，目前已经形成华南、华东、华北、华中四大分拨中心，未来还会将集散网络延伸到内地，建立全国性的仓储分拨网络。海外另设20家分公司，建自营/联营全球清关转运中心，为客户创造更好的物流体验。
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
          <div class="echartsBox" style="">
            <div class="ChinaMap" >
                   <chinaMap></chinaMap>
           </div>
           <div class="echartsContent" >
            <div class="flx-justify-end" style="margin-bottom: 40px;">
                <img :src="$ossUrl+'icons/listen.png'">
            </div>
            <div>
            立足本地收货，本地集散。美通在全国每家分公司都建立了周转和存储仓，目前已经形成华南、华东、华中、华北四大分拨中心，未来还会将集散网络延伸到内地，建立全国性的仓储分拨网络。
            </div>
        </div>
          </div>
          <div>
            <div class="companyAddress">
                国内分公司地址
            </div>
            <el-row>
                <el-col v-for="(item,index) in companyList" :key="index" :span="12">
                    <div class="companyBox ">
                        <div class="companyTitle">{{item.title}}</div>
                          <div class="companyContent">
                                <div v-for="(itemData,indexData) in item.contentList" :key="indexData"> {{itemData.content}}</div>
                            </div>
                    </div>
                </el-col>
            
                
            </el-row>
          </div>
          <div>
            <div class="companyAddress">
                国外分公司地址
            </div>
            <el-row>
                <el-col v-for="(item,index) in overCompanyList" :key="index" :span="12">
                    <div class="companyBox ">
                        <div class="companyTitle">
                            <div v-if="item.contentList[0].content !== ''"> {{item.title}}</div>
                            <div v-else class="flx-justify-between " style="line-height:90px"> 
                                <span>{{item.title}}</span>
                            </div>
                        </div>
                          <div class="overCompanyContent">
                                <div v-for="(itemData,indexData) in item.contentList" :key="indexData"> {{itemData.content}}</div>
                            </div>
                    </div>
                </el-col>
            
                
            </el-row>
          </div>
        </div>
    </div>
      
     
  </template>
  <script>
  import chinaMap from './chinaMap.vue';
  import { getPageBannerSrc } from '@/utils/bannerPreload';
  export default {
    name:"globalNetwork",
    components: {
        chinaMap
      // Switcher
    },
    data() {
      return {
       bannerRatio: 1440 / 717,
       newsList:[
        {
          id:'1',
          title:'喜报！热烈祝贺美通荣获亚马逊“2023金牌辅助”和“SPN一年级奖”通.祝贺美通荣获亚马逊“2023金牌辅助”和“SPN一年级前...',
          time:'2023-03-01 16:10',
          company:'美通供应链',
          img:this.$ossUrl+'images/news/newsIndex/people.png',
        },
        {
          id:'2',
          title:'喜报！热烈祝贺美通荣获亚马逊“2023金牌辅助”和“SPN一年级奖”通.祝贺美通荣获亚马逊“2023金牌辅助”和“SPN一年级前...',
          time:'2023-03-01 16:10',
          company:'美通供应链',
          img:this.$ossUrl+'images/news/newsIndex/people.png',
        },
       ],
       companyList:[
        {
            title:'深圳总部',
            contentList:[
                {
                    content:'深圳市龙岗区坂田街道稼先路993号赣锋科技大厦1栋A座17-19-22层',
                }
            ]
        },
        // {
        //     title:'机场分部',
        //     contentList:[
        //         {
        //             content:'深圳市宝安区福永街道怀德国际大厦1501-04'
        //         }
        //     ]
        // },
        // {
        //     title:'观澜分部',
        //     contentList:[
        //         {
        //             content:'深圳市龙华区观澜街道牛湖社区观天路17号大地城红木市场'
        //         }
        //     ]
        // },
        {
            title:'广州分公司',
            contentList:[
                {
                    content:'广州市白云区鹤龙东路159号欧派设计大厦1104室'
                }
            ]
        },
        {
            title:'中山分公司',
            contentList:[
                {
                    content:'中山东区利和国际金融中心4701-03'
                }
            ]
        },
        {
            title:'佛山分公司',
            contentList:[
                {
                    content:'佛山市顺德区顺联智造汇18座首层118-125号铺'
                }
            ]
        },
        {
            title:'东莞分公司',
            contentList:[
                {
                    content:'东莞市南城街道寰宇汇金中心9栋A座3503室'
                }
            ]
        },
        {
            title:'上海分公司',
            contentList:[
                {
                    content:'上海市闵行区申长路1688号中骏广场1幢201室'
                }
            ]
        },
        {
            title:'义乌分公司',
            contentList:[
                {
                    content:'浙江省义乌市北苑街道春晗路129号博尼产业园1号楼5号（美通供应链）'
                }
            ]
        },
        {
            title:'郑州分公司',
            contentList:[
                {
                    content:'郑州市航空港区洞庭湖路锦荣广场6号楼3楼311室'
                }
            ]
        },
        {
            title:'青岛分公司',
            contentList:[
                {
                    content:'青岛市市北区辽阳路567号浮山厚业中心5号楼1702户'
                }
            ]
        },
        {
            title:'合肥分公司',
            contentList:[
                {
                    content:'合肥市蜀山区经济开发区跨境电商监管区7号楼608-609室'
                }
            ]
        },
        {
            title:'宁波分公司',
            contentList:[
                {
                    content:'宁波市鄞州区首南街道天童南路700号荣安大厦B402'
                }
            ]
        },
        {
            title:'长沙分公司',
            contentList:[
                {
                    content:'长沙市岳麓区麓云路268号梅溪湖创新中心A区1802'
                }
            ]
        },
        {
            title:'厦门分公司',
            contentList:[
                {
                    content:'厦门市湖里区长虹路29号跨境电商产业园二号楼724-725室'
                }
            ]
        },
        {
            title:'成都分公司',
            contentList:[
                {
                    content:'四川省成都市武侯区锦晖西一街99号布鲁明顿广场B座1804'
                }
            ]
        },
        {
            title:'杭州分公司',
            contentList:[
                {
                    content:'杭州市滨江区江南大道星城中心A座906'
                }
            ]
        },
        {
            title:'汕头分公司',
            contentList:[
                {
                    content:'汕头市龙湖区龙华街道园林路龙头曲路片（7-9自编）'
                }
            ]
        },
        {
            title:'新疆阿拉山口',
            contentList:[
                {
                    content:'新疆博州阿拉山口市博尔塔拉路118号友好生活广场3号楼104房'
                }
            ]
        },
       {
            title:'塔城分公司',
            contentList:[
                {
                    content:'第九师163团1连南侧'
                }
            ]
        },
        {
            title:'苏州分公司',
            contentList:[
                {
                    content:'江苏省苏州市工业园区九章路具美大厦1107+1108室'
                }
            ]
        },
        {
            title:'常州分公司',
            contentList:[
                {
                    content:'江苏省常州市天宁区常州金融商务广场2号楼3楼T08'
                }
            ]
        },
        {
            title:'南京分公司',
            contentList:[
                {
                    content:'南京市江宁区江云路66号瑞浩大厦822'
                }
            ]
        },
        {
            title:'温州分公司',
            contentList:[
                {
                    content:'温州市龙湾区文昌创客小镇文昌路128号未来智慧城市产业园C栋8261室'
                }
            ]
        },
       ],
       overCompanyList:[
        {
            title:'美国',
            contentList:[
                {
                    content:'洛杉矶|纽约|芝加哥|新泽西州|宾夕法尼亚州分公司'
                }
            ]
        },
        {
            title:'英国',
            contentList:[
                {
                    content:'伦敦|菲利克斯托分公司'
                }
            ]
        },
        {
            title:'比利时',
            contentList:[
                {
                    content:'列日分公司'
                }
            ]
        },
        {
            title:'法国',
            contentList:[
                {
                    content:'巴黎分公司'
                }
            ]
        },
        {
            title:'德国',
            contentList:[
                {
                    content:'法兰克福|杜伊斯堡分公司'
                }
            ]
        },
        {
            title:'加拿大',
            contentList:[
                {
                    content:'温哥华|多伦多|卡尔加里分公司'
                }
            ]
        },
        {
            title:'日本',
            contentList:[
                {
                    content:'东京|大阪分公司'
                }
            ]
        },
        {
            title:'墨西哥',
            contentList:[
                {
                    content:'墨西哥城分公司'
                }
            ]
        },
        {
          title:'哈萨克斯坦',
          contentList:[
                {
                    content:'阿斯塔纳|阿拉木图分公司'
                }
            ]
        },
        {
          title:'越南',
          contentList:[
                {
                    content:'河内分公司'
                }
            ]
        },
        {
          title:'秘鲁',
          contentList:[
                {
                    content:'卡亚俄分公司'
                }
            ]
        },
        {
          title:'澳大利亚',
          contentList:[
                {
                    content:'悉尼分公司'
                }
            ]
        },
        {
            title:'白俄罗斯',
            contentList:[
                {
                    content:'明斯克分公司'
                }
            ]
        },
        {
          title:'厄瓜多尔',
          contentList:[
                {
                    content:'瓜亚基尔分公司'
                }
            ]
        },
        {
          title:'危地马拉',
          contentList:[
                {
                    content:'夸特扎尔分公司'
                }
            ]
        }
       ],
      };
    },
    computed: {
      bannerSrc() {
        return getPageBannerSrc(this.$route.path) || this.$ossUrl + 'images/智联全球.jpg';
      },
      bannerStyle() {
        return {
          backgroundImage: `url(${this.bannerSrc})`,
          aspectRatio: this.bannerRatio,
        };
      },
    },
    created() {
      this.loadBannerSize();
    },
    methods: {
      applyBannerRatio(img) {
        if (img.naturalWidth && img.naturalHeight) {
          this.bannerRatio = img.naturalWidth / img.naturalHeight;
        }
      },
      loadBannerSize() {
        const img = new Image();
        img.onload = () => this.applyBannerRatio(img);
        img.src = this.bannerSrc;
        if (img.complete) {
          this.applyBannerRatio(img);
        }
      },
    }
    
  };
  </script>
  <style src="./index.css" scoped>
  
  
  </style>